import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";

export const loadErrorPage = () => {
    console.log('Loading Error Page');

    //Módulo de análisis más vistos
    analisisMasVistos();
}

